module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollable"
  }, [(!_vm.receivedHistories.length) ? _c('p', {
    staticClass: "t-c",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("还没有任何收入记录哦~")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.receivedHistories), function(item, index) {
    return _c('gift-item', {
      directives: [{
        name: "longpress",
        rawName: "v-longpress",
        value: (function () { return _vm.$emit('longpress', item); }),
        expression: "()=>$emit('longpress', item)"
      }],
      key: item.id,
      attrs: {
        "item": item,
        "selectable": _vm.multi,
        "checked": _vm.selections && _vm.selections.indexOf(index) > -1
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/edit-history/' + item.id + '?type=received')
        },
        "change": function (checked) { return _vm.$emit('change', index, checked); }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-014074a8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Received.vue
// module id = 188
// module chunks = 16